export default {
    accountExclusions(customerId) {
        return `exclusions/customer/${customerId}/org/`;
    },
    contactExclusions(customerId) {
        return `exclusions/customer/${customerId}/lead/`;
    },
};
